import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./Map.css";
import { scaleLinear } from "d3-scale";
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Markers,
  Marker
} from "react-simple-maps";


// east and west is first (west is negative) and then north/south (sout is neg)
const markers = [
  { markerOffset: -45, name: "Los Angeles", coordinates: [-118.2437, 34.0522 ] },
  { markerOffset: -45, name: "Orlando", coordinates: [-81.3792, 28.5383 ] },
  { markerOffset: -45, name: "Berlin", coordinates: [13.4050, 52.5200 ] },
  { markerOffset: -45, name: "Stockholm", coordinates: [18.0686, 59.3293 ] },
];

const countries = ["United States of America", "Sweden", "Germany"];

class Map extends Component {

  state = {
    center: [10, 20],
    zoom: 1,
    cities: markers,
    clicked: false
  }

  handleCitySelection = (evt) => {
    const cityId = evt.target.getAttribute("data-city")
    const city = this.state.cities[cityId]
    this.setState({
      center: city.coordinates,
      zoom: 2,
      clicked: true
    })
  }

  handleReset = () => {
    this.setState({
      center: [10,20],
      zoom: 1,
      clicked: false
    })
  }
 
  render() {

    const reset_display = this.state.clicked ? "" : "none";
    const line_width = this.state.clicked ? .25 : .75;

    return(
      <div style={{backgroundColor: "#f3f3f3"}}>
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
          <div className="map-container-header py-4">We are International</div>
          {
            this.state.cities.map((city, i) => (
              <div
                key={i}
                className="map-selection-option px-4 py-1 shine"
                data-city={i}
                onClick={this.handleCitySelection}
                >
                { city.name }
              </div>
            ))
          }
          <div className={`map-selection-option py-1 px-4 shine ${reset_display}`} style={{color: "red"}}onClick={this.handleReset}>
            { "Reset" }
          </div>
          </div>
        </div>
        <ComposableMap  style={{ width: "100%" }}>
          <ZoomableGroup center={this.state.center} zoom={this.state.zoom} disablePanning>
          <Geographies geography={"world-110m.json"}>
          {(geographies, projection) => geographies.map((geography, i) => {
            return countries.indexOf(geography.properties.NAME) !== -1 ? <Geography
                key={ `geography-${i}` }
                cacheId={ `geography-${i}` }
                geography={ geography }
                projection={ projection }
                style={{
                  default: {
                    fill: "#607D8B",
                    stroke: "#FFFFFF",
                    strokeWidth: line_width,
                    outline: "none",
                  },
                  hover: {
                    fill: "#444",
                    stroke: "#607D8B",
                    strokeWidth: line_width,
                    outline: "none",
                  },
                  pressed: {
                    fill: "#FF5722",
                    stroke: "#607D8B",
                    strokeWidth: line_width,
                    outline: "none",
                  },
                }}
              />  :
                <Geography
                  key={ `geography-${i}` }
                  cacheId={ `geography-${i}` }
                  geography={ geography }
                  projection={ projection }
                  style={{
                    default: {
                      fill: "#ECEFF1",
                      stroke: "#607D8B",
                      strokeWidth: line_width,
                      outline: "none",
                    },
                    hover: {
                      fill: "#607D8B",
                      stroke: "#607D8B",
                      strokeWidth: line_width,
                      outline: "none",
                    },
                    pressed: {
                      fill: "#FF5722",
                      stroke: "#607D8B",
                      strokeWidth: line_width,
                      outline: "none",
                    },
                  }}
                />
          })}
          </Geographies>
          <Markers>
              {markers.map((marker, i) => (
                <Marker
                  key={i}
                  marker={marker}
                  style={{
                    default: { stroke: "#000" },
                    hover: { stroke: "#607D8B" },
                    pressed: { stroke: "#FFFFFF" },
                  }}
                  >
                  <g transform="translate(-12, -24)">
                    <path
                      fill="#FF0000"
                      strokeWidth="1"
                      strokeLinecap="square"
                      strokeMiterlimit="10"
                      strokeLinejoin="miter"
                      d="M20,9c0,4.9-8,13-8,13S4,13.9,4,9c0-5.1,4.1-8,8-8S20,3.9,20,9z"
                    />
                    <circle
                      fill="#EEE"
                      strokeWidth="1"
                      strokeLinecap="square"
                      strokeMiterlimit="10"
                      strokeLinejoin="miter"
                      cx="12"
                      cy="9"
                      r="3"
                    />
                  </g>
                </Marker>
              ))}
            </Markers>
          </ZoomableGroup>
        </ComposableMap>
      </div>
    )
  }
}

export default Map;


// WEBPACK FOOTER //
// ./src/components/About/Location/Map/Map.js